import { render } from "./PromocodeForm.vue?vue&type=template&id=1a0a0f7f"
import script from "./PromocodeForm.vue?vue&type=script&lang=js"
export * from "./PromocodeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__